import { inject, Injectable } from '@angular/core';
import { ReturnReasonService, SqliteService } from '@app/services';
import { ReturnReasonModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class ReturnReasonRepository
{
    private readonly keys = {
        tableName: 'return_reasons',
    };
    private sqliteService = inject(SqliteService);
    private returnReasonService = inject(ReturnReasonService);

    async getReturnReasons(): Promise<ReturnReasonModel[]>
    {
        const sql = `
            SELECT *
            FROM ${this.keys.tableName};
        `;

        const data = await this.sqliteService.get(sql) ?? [];

        return data as ReturnReasonModel[];
    }

    async downloadReturnReasons(): Promise<ReturnReasonModel[]>
    {
        const returnReasons = await this.returnReasonService.getReturnReasons();

        if (returnReasons.length > 0)
        {
            await this.saveReturnReasons(returnReasons);
        }

        return returnReasons;
    }

    async saveReturnReasons(returnReasons: ReturnReasonModel[]): Promise<void>
    {
        const columns = [
            'id',
            'external_id',
            'name',
        ];
        const batchSize = Math.floor(3000 / columns.length);

        for (let i = 0; i < returnReasons.length; i += batchSize)
        {
            const chunk = returnReasons.slice(i, i + batchSize);
            const valuePlaceholders = this.sqliteService.getValuePlaceholder(chunk.length, columns.length);
            const sql = `
                INSERT INTO ${this.keys.tableName} (${columns.join(', ')})
                VALUES ${valuePlaceholders} ON CONFLICT(id) DO
                UPDATE
                    SET
                        external_id = excluded.external_id,
                    name = excluded.name;
            `;
            const values = chunk.flatMap((r) => [r.id, r.external_id, r.name]);
            await this.sqliteService.save(sql, values);
        }
    }
}
